import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WbsTypeIdSelector } from '../../reducers/elementTypes';
import { currentProjectIdSelector, rootElementIdSelector } from '../../reducers/projects';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import WbsLayout from './WbsLayout';



const WbsLayoutContainerConnectSelector = immutableCreatorSelector(
  [
    WbsTypeIdSelector,
    rootElementIdSelector,
    currentProjectIdSelector,
  ],
  (
    wbsTypeId,
    rootElementId,
    currentProjectId,
  ) => {
    return {
      wbsTypeId,
      rootElementId,
      currentProjectId,
    };
  }
);

@connect(WbsLayoutContainerConnectSelector)
export default class WbsLayoutContainer extends Component {
  render() {
    const { children, wbsTypeId } = this.props;
    if (!wbsTypeId) return null;

    return (
      <WbsLayout {...this.props}>
        {children}
      </WbsLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WbsLayout/WbsLayoutContainer.js